import { Injectable } from '@angular/core';
import { WrapperHttpService } from '../../../../services/wrapper-http-service';
import { TransportOrderIdView } from '../../../../models/shipment-id-view.model';
import { API_URL } from '../../../../../services/config';
import { Observable } from 'rxjs';
import { ShipmentTransportOrderEndpoint } from '../../constants';
import { getQueryStringFromObject } from '../../../../../common';
import { ShipmentTransportOrderStatusChainModel } from '../../models';

@Injectable({ providedIn: 'root' })
export class ShipmentTransportOrderStatusChainService {
  constructor(private http: WrapperHttpService) {}

  getStatusChainData(
    transportOrderIdView: TransportOrderIdView,
  ): Observable<{ milestones: ShipmentTransportOrderStatusChainModel[] }> {
    const url =
      `${API_URL}${ShipmentTransportOrderEndpoint.Base}${ShipmentTransportOrderEndpoint.Tos}${ShipmentTransportOrderEndpoint.Milestones}?` +
      getQueryStringFromObject(transportOrderIdView);

    return this.http.withLoading().get(url);
  }
}
